import { Module } from 'vuex';
import { AutoLoginAppState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: AutoLoginAppState = {
    autoLoginApps: undefined,
    autoLoginAppsDetails: {
        autoLoginApp: undefined,
        nodes: undefined,
    },
    autoLoginAppCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    paFileDownload: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const autoLoginApp: Module<AutoLoginAppState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
